/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {InfoIcon} from '../../icons/InfoIcon';
import Tooltip from './Tooltip';

const useStyles = makeStyles(() => ({
  info : {
    height : '24px'
  }
}));

interface InfoTooltipProps {
  message?: string;
}

/**
 * This component will render an Info Icon with a tooltip on hover
 * with the given message.
 * 
 * ```typescript
 *  <InfoTooltip message={message} />
 * ```
 */
export const InfoTooltip = ({message}: InfoTooltipProps) => {
  const classes = useStyles();
  return (
    <Tooltip arrow
      title={message}>
      <span className={classes.info}><InfoIcon /></span>
    </Tooltip>
  );
};

export default React.memo(InfoTooltip);
